import { Path, SVG } from '@wordpress/components';

export const VendyLogoSVG = () => {
  return (
    <SVG width="274" height="188" viewBox="0 0 274 188" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path
        d="M223.601 37.0192C224.622 37.024 225.434 37.0192 225.434 37.0192L225.658 49.4416L274.301 24.6989L225.882 0V13.4106C225.882 13.4106 225.046 13.4447 224.01 13.4447L175.601 13.4155C170.471 13.4155 165.75 17.2464 163.315 21.8367L99.482 142.123C96.4788 147.76 98.6353 154.76 104.293 157.739C109.936 160.713 117.924 158.567 120.917 152.939L182.952 37.1944"
        fill="#0393FB"
      />
      <Path
        d="M0 43.998V67.2026H53.1898L98.7996 152.943C101.862 158.867 110.991 160.858 116.42 157.304C121.545 153.951 123.218 145.919 120.195 140.404L70.7803 50.3066C68.3101 45.7991 63.758 44.0029 58.8325 44.0029H0V43.998Z"
        fill="111213"
      />
      <Path
        opacity="0.82"
        d="M110.548 121.264L99.482 142.064C96.4788 147.88 98.6353 155.104 104.293 158.181C109.936 161.247 117.426 159.032 120.419 153.23L124.418 146.216L110.548 121.264Z"
        fill="#067CD1"
      />
    </SVG>
  );
};
